import { FC, memo } from "react";
import { Skeleton } from '@mui/material';
import { FeedbackInfo, FeedbackText } from "./patient-feedback.styles";
import { LiSeparator, List, ListItem } from "../../patient-profile-widget.styles";
import { DotSeparatedSkeleton } from "../../shared/skeleton/dot-separated-skeleton";
import { randomBetween } from "../../utils/random-between";

export const NotesSkeleton: FC = memo(() => {
  const itemCount = 5;
  
  const noteItem = (key: number) => {
    return <>
      <ListItem key={key}>
        <FeedbackInfo>
          <DotSeparatedSkeleton />
          <Skeleton variant="rounded" width={30} height={12} />
        </FeedbackInfo>
        <FeedbackText>
          <Skeleton variant="rounded" width={randomBetween(180, 240)} height={14} />
          <Skeleton variant="rounded" width={randomBetween(140, 200)} height={14} sx={{ marginTop: '6px' }} />
        </FeedbackText>
      </ListItem>
      {key !== itemCount - 1 && <LiSeparator key={1000 + key} />}
    </>
  }

  return <List>
    {Array.from({ length: itemCount }, (_, index) => noteItem(index))}
  </List>
});